module.exports = __webpack_public_path__ + "static/media/verificaçãoCNHOk.3390486e.jpg";